var bounceOut = require('./bounce-out');
function bounceIn(t) {
  return 1.0 - bounceOut(1.0 - t);
}
module.exports = bounceIn;